import React from "react";
import Tooltip from "../ui/Tooltip";
import { Move3d, Scaling } from "lucide-react";
import { RotationGizmoIcon } from "../ui/Icons";
import { INSPECTOR_CHROME_SECTION_ICON_CLASS } from "../../utils/inspectorChromeButtonClasses";

export default function TransformGizmoHeaderActions({
  disabled = false,
  disabledTitle = "Stop physics to edit transforms",
  showPositionGizmo = false,
  showRotationGizmo = false,
  showScaleGizmo = false,
  onTogglePositionGizmo,
  onToggleRotationGizmo,
  onToggleScaleGizmo,
}) {
  return (
    <>
      <Tooltip
        content={
          disabled
            ? disabledTitle
            : showPositionGizmo
              ? "Hide position gizmo"
              : "Show position gizmo"
        }
      >
        <button
          type="button"
          aria-label={showPositionGizmo ? "Hide position gizmo" : "Show position gizmo"}
          aria-pressed={showPositionGizmo}
          disabled={disabled}
          onClick={onTogglePositionGizmo}
          className={INSPECTOR_CHROME_SECTION_ICON_CLASS}
          style={{
            opacity: disabled ? 0.35 : showPositionGizmo ? 1 : 0.82,
          }}
        >
          <Move3d size={16} />
        </button>
      </Tooltip>
      <Tooltip
        content={
          disabled
            ? disabledTitle
            : showRotationGizmo
              ? "Hide rotation gizmo"
              : "Show rotation gizmo"
        }
      >
        <button
          type="button"
          aria-label={showRotationGizmo ? "Hide rotation gizmo" : "Show rotation gizmo"}
          aria-pressed={showRotationGizmo}
          disabled={disabled}
          onClick={onToggleRotationGizmo}
          className={INSPECTOR_CHROME_SECTION_ICON_CLASS}
          style={{
            opacity: disabled ? 0.35 : showRotationGizmo ? 1 : 0.82,
          }}
        >
          <RotationGizmoIcon size={16} />
        </button>
      </Tooltip>
      {typeof onToggleScaleGizmo === "function" ? (
        <Tooltip
          content={
            disabled ? disabledTitle : showScaleGizmo ? "Hide scale gizmo" : "Show scale gizmo"
          }
        >
          <button
            type="button"
            aria-label={showScaleGizmo ? "Hide scale gizmo" : "Show scale gizmo"}
            aria-pressed={showScaleGizmo}
            disabled={disabled}
            onClick={onToggleScaleGizmo}
            className={INSPECTOR_CHROME_SECTION_ICON_CLASS}
            style={{
              opacity: disabled ? 0.35 : showScaleGizmo ? 1 : 0.82,
            }}
          >
            <Scaling size={16} />
          </button>
        </Tooltip>
      ) : null}
    </>
  );
}
